__turbopack_context__.v({
  "grid": "card-grid-module__W9tATa__grid",
  "item": "card-grid-module__W9tATa__item",
});
